import React from 'react';
interface PortraitProps {
  src: string;
  alt: string;
  /** Where the portrait fades out so it sits inside the frame, not on top of it. */
  fade?: 'left' | 'none';
  className?: string;
}

/**
 * Clinician photography, blended into the dark green canvas rather than pasted
 * on it: monochrome subjects, screen-blended so their charcoal backdrop drops
 * away and only the person remains.
 */
export function Portrait({
  src,
  alt,
  fade = 'left',
  className = ''
}: PortraitProps) {
  const mask = fade === 'left' ? 'linear-gradient(to right, transparent 0%, black 42%, black 100%)' : undefined;
  return <img src={src} alt={alt} className={`h-full w-full object-cover object-top opacity-90 mix-blend-screen ${className}`} style={mask ? {
    maskImage: mask,
    WebkitMaskImage: mask
  } : undefined} data-id="element-164" data-mp="yrvnnfpz2y64" />;
}